import { createAsyncThunk } from "@reduxjs/toolkit";

import api from "Service/api/api";
import {
  IDeleteReducerWithCallback,
  IDetailReducer,
} from "Shared/Types/shared";
import {
  IExpenseLimitParams,
  IExpenseSearchParams,
} from "Shared/Types/expense";
import {
  ExpenseCreateRequest,
  ExpenseUpdateRequest,
  PatchedExpenseTypeRequest,
} from "Shared/Types/fleetmanagementapi";
import {
  IReducerWithCallbackWithError,
  IUpdateReducerWithCallback,
} from "Shared/Types/shared";
import {
  IAddDocumentsToEntityTypes,
  IAddFilesToEntityTypes,
} from "Shared/Types/file";

export const getExpenseList = createAsyncThunk(
  "expense/getExpenseList",
  async (params: IExpenseSearchParams | null) => {
    try {
      const response = await api.expense.getExpenseList(params);
      return response.data;
    } catch (error) {
      console.error(error);
      throw error;
    }
  },
);

export const getVehiclesListWithExpenses = createAsyncThunk(
  "expense/getVehiclesListWithExpenses",
  async (params: IExpenseSearchParams | null) => {
    try {
      const response = await api.expense.getVehiclesWithExpense(params);
      return response.data;
    } catch (error) {
      console.error(error);
      throw error;
    }
  },
);

export const deleteExpense = createAsyncThunk(
  "expense/deleteExpense",
  async ({ id, onError, onSuccess }: IDeleteReducerWithCallback) => {
    try {
      const response = await api.expense.deleteExpense(id);
      onSuccess?.();
      return response.data;
    } catch (error) {
      onError?.();
      console.error(error);
      throw error;
    }
  },
);
export const createExpense = createAsyncThunk(
  "expense/createExpense",
  async ({
    data,
    onError,
    onSuccess,
  }: IReducerWithCallbackWithError<ExpenseCreateRequest>) => {
    try {
      const response = await api.expense.createExpense(data);
      onSuccess?.();
      return response.data;
    } catch (error) {
      onError?.();
      throw error;
    }
  },
);

export const updateExpense = createAsyncThunk(
  "expense/updateExpense",
  async ({
    data,
    id,
    onError,
    onSuccess,
  }: IUpdateReducerWithCallback<ExpenseUpdateRequest>) => {
    try {
      const response = await api.expense.updateExpense(id, data);
      onSuccess?.();
      return response.data;
    } catch (error) {
      onError?.();
      throw error;
    }
  },
);
export const createExpenseTypes = createAsyncThunk(
  "expense/createExpenseType",
  async ({
    data,
    onError,
    onSuccess,
  }: IReducerWithCallbackWithError<PatchedExpenseTypeRequest>) => {
    try {
      const response = await api.expense.createExpenseTypes(data);
      onSuccess?.();
      return response.data;
    } catch (error) {
      onError?.();
      throw error;
    }
  },
);

export const getExpenseTypeList = createAsyncThunk(
  "expense/getExpenseTypeList",
  async (params: IExpenseLimitParams) => {
    try {
      const response = await api.expense.getExpenseTypes(params);
      return response.data;
    } catch (error) {
      console.error(error);
      throw error;
    }
  },
);
export const getExpenseDetail = createAsyncThunk(
  "expense/getExpenseDetail",
  async ({ id, onError, onSuccess }: IDetailReducer) => {
    try {
      const response = await api.expense.getExpenseDetail(id);
      onSuccess?.();
      return response.data;
    } catch (error) {
      onError?.();
      throw error;
    }
  },
);
export const createExpenseComment = createAsyncThunk(
  "expense/createExpenseComment",
  async ({ data, onError, onSuccess }: IReducerWithCallbackWithError<any>) => {
    try {
      const response = await api.expense.createExpenseComment(data);
      onSuccess?.();
    } catch (error) {
      onError?.();
      throw error;
    }
  },
);

export const deleteExpenseComment = createAsyncThunk(
  "expense/deleteExpenseComment",
  async ({ id, onError, onSuccess }: IDeleteReducerWithCallback) => {
    try {
      const response = await api.expense.deleteExpenseComment(id);
      onSuccess?.();
      return response.data;
    } catch (error) {
      onError?.();
      throw error;
    }
  },
);
export const createExpenseDocument = createAsyncThunk(
  "expense/createExpenseDocument",
  async ({
    id,
    onSuccessUploadFiles,
    onErrorUploadFiles,
    files,
  }: IAddFilesToEntityTypes) => {
    try {
      const response = await api.expense.createExpenseDocument(id, { files });
      onSuccessUploadFiles?.();
      return response.data;
    } catch (error) {
      onErrorUploadFiles?.();
      throw error;
    }
  },
);
export const deleteExpenseDocument = createAsyncThunk(
  "expense/deleteExpenseDocument",
  async ({
    id,
    onErrorUploadFiles,
    files,
    onSuccessUploadFiles,
  }: IAddFilesToEntityTypes) => {
    try {
      const response = await api.expense.deleteExpenseDocument(id, { files });
      onSuccessUploadFiles?.();
      return response.data;
    } catch (error) {
      onErrorUploadFiles?.();
      throw error;
    }
  },
);
